import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import { BUTTON_TYPES } from 'constants/button'
import Typo from 'constants/typography'
import BlackBar from 'components/common/black-bar'
import Button from 'components/common/button'
import Dialog from 'components/common/dialog'
import Icon, { ICONS, ICON_SIZE } from 'components/common/icon'
import BackdropModal from 'components/portal/backdrop-modal'
import { REFERRAL_HISTORY_LOCIZE } from 'components/referral/landing/landing-desktop/history/const'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import styles from './styles.scss'

const ReferralHistoryIncompleteInfo = ({ t }) => {
  const [isDialogShow, setIsDialogShow] = useState(false)

  const openDialog = useCallback(() => setIsDialogShow(true), [setIsDialogShow])
  const closeDialog = useCallback(
    () => setIsDialogShow(false),
    [setIsDialogShow],
  )

  return (
    <div className="referral-incomplete-info">
      <style jsx>{styles}</style>
      <BlackBar className={Typo.caption}>
        <div className="referral-incomplete-info__content">
          <Icon src={ICONS.loyalty} />
          <div className="referral-incomplete-info__label">
            {hasLocizeTranslation(
              t,
              REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_IN_COMPLETE_INFO.key,
              REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_IN_COMPLETE_INFO.text,
            )}
            <Button
              className="referral-incomplete-info__cta"
              type={BUTTON_TYPES.link}
              onClick={openDialog}
            >
              {hasLocizeTranslation(
                t,
                REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_IN_COMPLETE_LEARN_MORE
                  .key,
                REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_IN_COMPLETE_LEARN_MORE
                  .text,
              )}
            </Button>
          </div>
        </div>
      </BlackBar>
      <BackdropModal isOpen={isDialogShow}>
        <Dialog closable onClose={closeDialog}>
          <div className="referral-incomplete-info__dialog">
            <Icon src={ICONS.pomeloCredit} size={ICON_SIZE.extraLarge} />
            <span className={Typo.title3}>
              {hasLocizeTranslation(
                t,
                REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_CASHBACK_REJECTED_TITLE
                  .key,
                REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_CASHBACK_REJECTED_TITLE
                  .text,
              )}
            </span>
            <span className={Typo.body2}>
              {hasLocizeTranslation(
                t,
                REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_CASHBACK_REJECTED_INFO
                  .key,
                REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_CASHBACK_REJECTED_INFO
                  .text,
              )}
            </span>
          </div>
        </Dialog>
      </BackdropModal>
    </div>
  )
}

ReferralHistoryIncompleteInfo.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withI18next()(ReferralHistoryIncompleteInfo)
